<template>
  <div
    class="b-spinner__input"
    :class="{ 'b-spinner__input--disabled': loadingId === item[itemValue] }"
  >
    <button
      @click="decItemQuantity"
      :disabled="item.qty <= 1"
      tabindex="-1"
      type="button"
    >
      <i class="i-minus"></i>
    </button>
    <label>
      <input
        :readonly="loadingId === item[itemValue]"
        class="js-spinner-input"
        type="number"
        value="1"
        min="1"
        @input="handleInput"
        v-model="item.qty"
      />
    </label>
    <button @click="incItemQuantity" tabindex="-1" type="button">
      <i class="i-plus"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "ButtonCounterDeprecated",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    loadingId: {
      type: [String, Number, null],
      default: null
    },
    itemValue: {
      type: String,
      default: "id"
    }
  },
  methods: {
    incItemQuantity() {
      this.item.qty = Number(this.item.qty) + 1;
      this.updateShippingEstimate();
      this.$emit("change-quantity");
    },
    decItemQuantity() {
      this.item.qty = Number(this.item.qty) > 1 ? Number(this.item.qty) - 1 : 1;
      this.updateShippingEstimate();
      this.$emit("change-quantity");
    },
    updateShippingEstimate() {
      if (Array.isArray(this.item.shippingEstimate)) {
        for (let p in this.item.shippingEstimate) {
          if (Number(this.item.shippingEstimate[p].allWeekCount) === 1000) {
            this.item.shippingEstimate.splice(p, 1);
          }
        }
      }
    },
    handleInput(event) {
      // eslint-disable-next-line no-undef
      const $input = $(event.target);
      const inputMin = Number($input.attr("min") || 1);
      const inputMax = Number($input.attr("max") || Infinity);

      const newQty = Number($input.val());
      let result;

      if (newQty > inputMax) {
        result = inputMax;
      } else if (newQty < inputMin) {
        result = inputMin;
      } else {
        result = newQty;
      }

      this.item.qty = result;
      this.$emit("change-quantity");
    }
  }
};
</script>

<style lang="scss" scoped>
.b-spinner__input {
  margin-right: 9px;

  button {
    display: flex;
    outline: none;
    color: var(--v-primary-base);
  }

  input {
    outline: none;
  }

  i {
    font-style: normal;
  }
}

.b-spinner__input--disabled {
  button,
  input {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
